import { render, staticRenderFns } from "./VerifyOnlyPage.vue?vue&type=template&id=3987a526"
import script from "./VerifyOnlyPage.vue?vue&type=script&lang=js"
export * from "./VerifyOnlyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports